module.exports = __webpack_public_path__ + "static/img/GoBackCircle.f82efaa.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/Brand/GoBackCircle.png
// module id = 1166
// module chunks = 18